import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import * as React from 'react';

const Action = () => {
  const {
    menu,
    hide,
  } = useMenuBalanceContext();

  if (!menu.action) {
    return null;
  }
  return (
    <div className="dropdown-flat-header">
      <MenuItem
        label={menu.action.label}
        route={menu.action.route}
        url={menu.action.url}
        className="btn btn-primary btn-block"
        onClick={() => {
          hide();
        }}
        visible={menu.action.visible}
      />
    </div>
  );
};

export { Action };
